const selectProps = {
  allowClear: true,
  showSearch: true,
  getPopupContainer: triggerNode => triggerNode.parentNode,
  filterOption: (input, option) => {
    return option.label && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  },
};

//const fieldNames = { label: 'name', value: 'value', children: 'children' };

export { selectProps };
